import { Parse } from "parse";

Parse.initialize(
  process.env.REACT_APP_APP_ID,
  null,
  process.env.REACT_APP_MASTER_KEY
);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

export const gameRecordsExports = async (params) => {
  const filter = params;

  const Resource = Parse.Object.extend("GameCatalogue");
  const query = new Parse.Query(Resource);
  query.descending("createdAt");

  filter &&
    Object.keys(filter).map((f) =>
      typeof filter[f] === "string"
        ? query.matches(f, filter[f], "i")
        : query.equalTo(f, filter[f])
    );
  try {
    const results = await query.find();
    return {
      data: results.map((o) => ({ id: o.id, ...o.attributes })),
    };
  } catch (error) {
    return { error: "Failed to generate gameRecordsExports." };
  }
};

export const rechargeRecordsExports = async (params) => {
  const filter = params;
  const currentUser = await Parse.User.currentAsync();

  const Resource = Parse.Object.extend("Transactions");
  const query = new Parse.Query(Resource);
  query.equalTo("txn_type", 0);
  query.notEqualTo("user", currentUser);
  query.descending("txn_datetime");
  query.limit(50000);
  query.include("manager");

  if (filter.username) {
    filter &&
      Object.keys(filter).map((f) =>
        typeof filter[f] === "string"
          ? query.matches(f, filter[f], "i")
          : query.equalTo(f, filter[f])
      );
  } else if (filter.manager) {
    const userQuery = new Parse.Query(Parse.User);
    userQuery.equalTo("objectId", filter.manager);
    const managers = await userQuery.find({ useMasterKey: true });

    if (managers.length > 0) {
      const managerPointers = managers.map((m) => m.toPointer());
      query.containedIn("manager", managerPointers);
    } else {
      // Ensure no results returned if no manager matches
      query.equalTo("objectId", "__no_such_id__");
    }
  }

  try {
    const results = await query.find();

    const formattedData = results.map((o) => {
      const manager = o.get("manager");

      // Ensure manager is valid and has the name property
      const managerName = manager ? manager.get("username") : "No Manager"; // Default to "No Manager" if no manager

      return {
        id: o.id,
        txn_datetime: o.get("txn_datetime"),
        amount: o.get("amount"),
        remarks: o.get("remarks"),
        username: o.get("username"),
        manager: {
          name: managerName,
        },
      };
    });

    return {
      data: formattedData,
    };
  } catch (error) {
    return { error: "Failed to generate rechargeRecordsExports." };
  }
};

export const redeemRecordsExports = async (params) => {
  const filter = params;
  const currentUser = await Parse.User.currentAsync();

  const Resource = Parse.Object.extend("Transactions");
  const query = new Parse.Query(Resource);
  query.equalTo("txn_type", 1);
  query.notEqualTo("user", currentUser);
  query.descending("txn_datetime");
  query.limit(50000);
  query.include("manager");

  if (filter.username) {
    filter &&
      Object.keys(filter).map((f) =>
        typeof filter[f] === "string"
          ? query.matches(f, filter[f], "i")
          : query.equalTo(f, filter[f])
      );
  } else if (filter.manager) {
    const userQuery = new Parse.Query(Parse.User);
    userQuery.equalTo("objectId", filter.manager);
    const managers = await userQuery.find({ useMasterKey: true });

    if (managers.length > 0) {
      const managerPointers = managers.map((m) => m.toPointer());
      query.containedIn("manager", managerPointers);
    } else {
      // Ensure no results returned if no manager matches
      query.equalTo("objectId", "__no_such_id__");
    }
  }

  try {
    const results = await query.find();

    const formattedData = results.map((o) => {
      const manager = o.get("manager");

      // Ensure manager is valid and has the name property
      const managerName = manager ? manager.get("username") : "No Manager"; // Default to "No Manager" if no manager

      return {
        id: o.id,
        txn_datetime: o.get("txn_datetime"),
        amount: o.get("amount"),
        remarks: o.get("remarks"),
        username: o.get("username"),
        manager: {
          name: managerName,
        },
      };
    });

    return {
      data: formattedData,
    };
  } catch (error) {
    return { error: "Failed to generate redeemRecordsExports." };
  }
};

export const userListExports = async (params) => {
  const filter = { ...(params || {}) };

  const query = new Parse.Query(Parse.User);
  query.descending("createdAt");
  query.limit(50000);

  // Include the manager & role pointer
  query.include("manager");
  query.include("role");
  const currentUser = await Parse.User.currentAsync();
  if (currentUser) {
    query.notEqualTo("objectId", currentUser.id);
  }
  // --- Manager filter: resolve name/username -> pointer(s)
  if (filter.manager) {
    try {
      const userQuery = new Parse.Query(Parse.User);
      userQuery.equalTo("objectId", filter.manager);
      const managers = await userQuery.find({ useMasterKey: true });

      if (managers.length > 0) {
        const managerPointers = managers.map((m) => m.toPointer());
        query.containedIn("manager", managerPointers);
      } else {
        // Ensure no results returned if no manager matches
        query.equalTo("objectId", "__no_such_id__");
      }
    } catch (e) {
      console.error("Manager filter error:", e);
      return { error: "Failed to apply manager filter." };
    }

    // Prevent generic loop from trying to `matches` on a pointer field
    delete filter.manager;
  }

  // --- Apply remaining filters (string -> matches, others -> equalTo)
  Object.keys(filter).forEach((f) => {
    const v = filter[f];
    if (v === undefined || v === null || v === "") return;

    if (typeof v === "string") {
      query.matches(f, v, "i");
    } else if (Array.isArray(v)) {
      query.containedIn(f, v);
    } else if (typeof v === "object" && v.__type === "Pointer" && v.className && v.objectId) {
      const Ptr = Parse.Object.extend(v.className);
      query.equalTo(f, Ptr.createWithoutData(v.objectId));
    } else {
      query.equalTo(f, v);
    }
  });

  try {
    const results = await query.find();

    const formattedData = results.map((o) => {
      const manager = o.get("manager");
      const role = o.get("role");
      return {
        id: o.id,
        isActive: o.get("isActive"),
        username: o.get("username"),
        name: o.get("name"),
        email: o.get("publicEmail"),
        phone: o.get("phone"),
        deviceID: o.get("deviceID"),
        role: { name: role ? role.get("name") : "No Role" },
        balance: o.get("balance"),
        createdAt: o.get("createdAt"),
        manager: { name: manager ? manager.get("name") : "No Manager" },
      };
    });

    return { data: formattedData };
  } catch (error) {
    console.error(error);
    return { error: "Failed to generate userListExports." };
  }
};


export const gamesCoinsExports = async (filterValues, sort) => {
  const filter = filterValues || {};
  const { field = "totalBetAmount", order = "DESC" } = sort || {};

  // Ensure we have the current user for _rperm scoping
  let user = Parse.User.current();
  if (!user) return { data: [] };
  user = await user.fetch();

  // ---------- helpers ----------
  const dateMatchStage = (startDate, endDate) => {
    const match = {};
    if (startDate) match.$gte = new Date(startDate);
    if (endDate) {
      const end = new Date(endDate);
      end.setDate(end.getDate() + 1);
      match.$lt = end;
    }
    return Object.keys(match).length > 0
      ? { $match: { gamePlayedDate: match } }
      : null;
  };

  const variantMatchStage = (variant) =>
    variant && variant !== "all" ? { $match: { type: variant } } : null;

  const gameNameMatchStage = (gameName) =>
    gameName && gameName.trim() !== ""
      ? { $match: { gameName: { $regex: gameName, $options: "i" } } }
      : null;

  const sortStage = { $sort: { [field]: order === "ASC" ? 1 : -1 } };
  const includeTestingUsers = filter.includeTestingUsers === true;

  // ---------- base match filters ----------
  const gameCoinsList = [];

  const gameDateMatch = dateMatchStage(filter.startDate, filter.endDate);
  const gameVariantMatch = variantMatchStage(filter.gameVariant);
  const gameNameMatch = gameNameMatchStage(filter.gameName);

  if (gameDateMatch) gameCoinsList.push(gameDateMatch);
  if (gameVariantMatch) gameCoinsList.push(gameVariantMatch);
  if (gameNameMatch) gameCoinsList.push(gameNameMatch);

  // ACL + Player + Testing filters
  gameCoinsList.push(
    { $match: { _rperm: user.id } },
    //{ $match: { role: "Player" } }
  );

  if (!includeTestingUsers) {
    gameCoinsList.push({
      $match: {
        isTestingUserData: { $ne: true },
      },
    });
  }

  // ---------- Group & Projection ----------
  gameCoinsList.push(
    {
      $group: {
        _id: "$gameId",
        id: { $first: "$gameId" },
        totalCount: { $sum: 1 },
        totalBetAmount: { $sum: "$totalBetAmount" },
        totalWinAmount: { $sum: "$totalWinAmount" },
        gameName: { $first: "$gameName" },
        type: { $first: "$type" },
      },
    },
    {
      $project: {
        id: "$_id",
        type: 1,
        gameName: 1,
        totalBetAmount: 1,
        totalWinAmount: 1,
        rtp: {
          $cond: [
            { $eq: ["$totalBetAmount", 0] },
            0,
            {
              $multiply: [
                { $divide: ["$totalWinAmount", "$totalBetAmount"] },
                100,
              ],
            },
          ],
        },
        netAmount: {
          $subtract: ["$totalBetAmount", "$totalWinAmount"],
        },
      },
    },
    sortStage
  );

  try {
    const data = await new Parse.Query("GameCoins").aggregate(gameCoinsList, {
      useMasterKey: true,
    });

    return { data };
  } catch (error) {
    console.error("gamesCoinsExports error:", error);
    return { error: "Failed to generate gamesCoinsExports." };
  }
};



export const dailyCoinsExports = async (filterValues, sort) => {
  const filter = filterValues;
  const { field, order } = sort;
  let user = Parse.User.current();
  user = await user.fetch();

  const dateMatchStage = (startDate, endDate) => {
    const match = {};
    if (startDate) match.$gte = new Date(startDate);
    if (endDate) {
      const end = new Date(endDate);
      end.setDate(end.getDate() + 1);
      match.$lt = end;
    }
    return Object.keys(match).length > 0
      ? { $match: { gamePlayedDate: match } }
      : null;
  };

  const variantMatchStage = (variant) =>
    variant && variant !== "all" ? { $match: { type: variant } } : null;
  const sortStage = {
    $sort: {
      [field]: order === "ASC" ? 1 : -1,
    },
  };

  // -------------------- COMMON FILTERS --------------------
  const matchStages = [];

  const gameDateMatch = dateMatchStage(filter.startDate, filter.endDate);
  const gameVariantMatch = variantMatchStage(filter.gameVariant);

  if (gameDateMatch) matchStages.push(gameDateMatch);
  if (gameVariantMatch) matchStages.push(gameVariantMatch);

  matchStages.push(
    { $match: { _rperm: user.id } },
    //{ $match: { role: "Player" } }
  );

  // Optional: Exclude testing users
  if (!filter.includeTestingUsers) {
    matchStages.push({ $match: { isTestingUserData: { $ne: true } } });
  }

  // -------------------- DATA PIPELINE --------------------
  const gameCoinsList = [
    ...matchStages,
    {
      $addFields: {
        createdDateStr: {
          $dateToString: {
            format: "%Y-%m-%d",
            date: "$gamePlayedDate",
          },
        },
      },
    },
    {
      $group: {
        _id: "$createdDateStr",
        totalBetAmount: { $sum: "$totalBetAmount" },
        totalWinAmount: { $sum: "$totalWinAmount" },
        sessionCount: { $sum: "$sessionCount" },
      },
    },
    {
      $project: {
        id: "$_id",
        totalBetAmount: 1,
        totalWinAmount: 1,
        sessionCount: 1,
        rtp: {
          $cond: [
            { $eq: ["$totalBetAmount", 0] },
            0,
            {
              $multiply: [
                { $divide: ["$totalWinAmount", "$totalBetAmount"] },
                100,
              ],
            },
          ],
        },
        netAmount: {
          $subtract: ["$totalBetAmount", "$totalWinAmount"],
        },
      },
    },
    sortStage
  ];

  try {
    const [data] = await Promise.all([
      new Parse.Query("GameCoins").aggregate(gameCoinsList, { useMasterKey: true })
    ]);
    return {
      data,
    };
  } catch (error) {
    return { error: "Failed to generate dailyCoinsExports." };
  }
};
